import { withRouter, matchPath } from 'react-router-dom';
import T from 'prop-types';
import { ability } from '@oliasoft/authorization-ui';
import { TopBar as TopBarBase, PrintHeader } from '@oliasoft-open-source/react-ui-library';
import translations from '~common/Internationalisation/translation-map.json';
import { checkUserAssignedToCustomer } from '~modules/Companies/api';
import {
  canCreateCustomerInternal,
  canReadIdentificationsInternal,
  canReadLicenseInternal,
  canReadOrganizationsInternal,
  canReadCustomer,
  canReadProductsInternal,
  canReadExternalUsersRequestsInternal,
  canReadSurveysInternal,
} from '~permissions';
import  useFetch  from '~hooks/useFetch';
import useLogout from '~hooks/useLogout';
import LanguagePicker from '~components/LanguagePicker';
import Logo from '../../styles/images/logo.svg';
import './styles.css';
import { UserMenu } from './UserMenu/UserMenu';
import { loadLocalStoreData } from '../../services/local-storage.service';
import { NAVIGATION_CONSTANTS } from '../../constants';
import { useTranslation } from 'react-i18next';

const headerItems = (t) => [
  {
    to: NAVIGATION_CONSTANTS.COMPANY_CREATION_ROUTE,
    iconClass: 'pencil alternate icon',
    text: t(translations.header_accountRegistration),
    can: canCreateCustomerInternal,
  },
  {
    to: NAVIGATION_CONSTANTS.CUSTOMER_ADMINISTRATION_ROUTE,
    iconClass: 'building icon',
    text: t(translations.header_customerOverview),
    can: canReadOrganizationsInternal,
  },
  {
    to: NAVIGATION_CONSTANTS.COMPANY_ADMINISTRATION_ROUTE,
    iconClass: 'building icon',
    text: t(translations.header_companyAdministration),
    can: canReadCustomer,
  },
  {
    to: NAVIGATION_CONSTANTS.LICENSE_ADMINISTRATION_ROUTE,
    iconClass: 'book icon',
    text: t(translations.header_licenseAdministration),
    can: canReadLicenseInternal,
  },
  {
    to: NAVIGATION_CONSTANTS.IDENTIFICATION_ROUTE,
    iconClass: 'user icon',
    text: t(translations.header_identifications),
    can: canReadIdentificationsInternal,
  },
  {
    to: NAVIGATION_CONSTANTS.PAYLOAD_COMPARISON_ROUTE,
    text: t(translations.header_payloadComparison),
    can: canReadProductsInternal, // TODO: set iconClass and verify can
  },
  {
    to: NAVIGATION_CONSTANTS.EXTERNAL_USERS_REQUESTS_ROUTE,
    text: t(translations.header_externalUsersRequests),
    can: canReadExternalUsersRequestsInternal,
  },
  {
    to: NAVIGATION_CONSTANTS.SURVEYS_ROUTE,
    text: t(translations.header_surveys),
    can: canReadSurveysInternal,
  },
];

const Header = ({ history, location }) => {
  const {
    result: { hasCustomer },
  } = useFetch(checkUserAssignedToCustomer, [], { hasCustomer: false });
  const handleLogout = useLogout();

  const userProfile = loadLocalStoreData('user', {}, true);
  const { firstName, lastName } = userProfile;

  const buildNavItem = ({ to, text, can }) => {
    const active = !!matchPath(location.pathname, to);
    const link = (
      {
        key: `${to}-${text}`,
        type: 'Link',
        label: text,
        onClick: () => history.push(to),
        can,
        active
      }
    );
    return link;
  };

  const generatedContent = (headerItems, hasCustomer) => {
    const contentArray = [];
    headerItems.forEach(item => {
      if (!hasCustomer && item.to === NAVIGATION_CONSTANTS.COMPANY_ADMINISTRATION_ROUTE) {
        return;
      }
      if (ability.can(item.can.action, item.can.subject)) {
        contentArray.push(buildNavItem({ ...item }));
      }
    });

    return contentArray;
  };

  const redirectToRootPage = () => history.push(NAVIGATION_CONSTANTS.ROOT);

  const logoAlt = 'Oliasoft';

  const { t } = useTranslation();
  const content = generatedContent(headerItems(t), hasCustomer);

  return (
    <>
      <PrintHeader logo={Logo} logoWidth="349px" alt={logoAlt} onClick={redirectToRootPage} />
      <TopBarBase
        title={{
          logo: <img src={Logo} alt={logoAlt} style={{ height: 18, cursor: 'pointer' }} onClick={redirectToRootPage} />,
        }}
        content={content}
        contentRight={[
          {
            type: 'Component',
            component: <LanguagePicker />
          },
          {
            type: 'Component',
            component: (
              <UserMenu
                mainPath=""
                navToUserProfile={() => history.push(NAVIGATION_CONSTANTS.SETTINGS_ROUTE)}
                onClickLogOut={handleLogout}
                isCompanyMode={false}
                userName={`${firstName} ${lastName}`}
              />
            ),
          },
        ]}
      />
    </>
  );
};

Header.propTypes = {
  history: T.shape({
    push: T.func,
  }).isRequired
};
export default withRouter(Header);
